import { gql } from "lib/apolloClient";

const basicUserFragment = gql`
  fragment basicUserItem on User {
    id
    type
    firstName
    middleName
    lastName
    profileImage
  }
`;

export const getStaffMembersWithPermsQuery = gql`
  query getStaffMembers(
    $organizationId: ID!
    $curriculumProgramId: ID!
    $first: Int
    $filters: OrgConnectionFilterInput
    $circularReviewerFilters: StaffCircularReviewersFilter!
    $configurationFilter: [String!]
    $staffCoursesFilters: CourseFilter
  ) {
    node(id: $organizationId, type: ORGANIZATION) {
      id
      ... on Organization {
        staff(first: $first, filters: $filters) {
          edges {
            node {
              ...basicUserItem
              displayRole
              courses(filters: $staffCoursesFilters) {
                id
                title
              }
              circularReviewers(filters: $circularReviewerFilters) {
                ...basicUserItem
              }
              permissions(
                curriculumProgramId: $curriculumProgramId
                configurations: $configurationFilter
              ) {
                configuration {
                  configurations {
                    id
                    value
                    valueType
                    configuration
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  ${basicUserFragment}
`;

export const getAllStaffMembersQuery = gql`
  query getStaffMembers(
    $organizationId: ID!
    $filters: OrgConnectionFilterInput
  ) {
    node(id: $organizationId, type: ORGANIZATION) {
      id
      ... on Organization {
        staff(filters: $filters) {
          edges {
            node {
              ...basicUserItem
            }
          }
        }
      }
    }
  }

  ${basicUserFragment}
`;

export const getDefaultReviewSettingsQuery = gql`
  query getDefaultReviewSettings(
    $id: ID!
    $input: DefaultReviewSettingsInput!
  ) {
    node(id: $id, type: ORGANIZATION) {
      id
      ... on Organization {
        defaultReviewSettings(input: $input) {
          defaultReviewSettings
          defaultReviewers {
            ...basicUserItem
          }
        }
      }
    }
  }

  ${basicUserFragment}
`;

export const getOrganizationCoursesQuery = gql`
  query getOrganizationCourses(
    $id: ID!
    $courseFilterInput: CourseFilterInput
  ) {
    node(id: $id, type: ORGANIZATION) {
      id
      ... on Organization {
        courses(filters: $courseFilterInput) {
          edges {
            node {
              id
              title
            }
          }
        }
      }
    }
  }
`;
